@if (shouldShow()) {
  <span class="validation-error">
    {{getErrorMessage()}}
  </span>
}
@if (showFormLevelErrors && group.invalid) {
  <span class="validation-error">
    {{customErrorMessage}}
  </span>
}
